import React from 'react';
import {
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  FluentProvider,
  TableColumnDefinition,
  createTableColumn,
  webLightTheme,
} from '@fluentui/react-components';
import ICompanyGroupCompany from '../../../utils/types/ICompanyGroupCompany';

const columns: TableColumnDefinition<ICompanyGroupCompany>[] = [
  createTableColumn<ICompanyGroupCompany>({
    columnId: 'name',
    compare: (a, b) => a.entityLegalName.localeCompare(b.entityLegalName),
    renderHeaderCell: () => <h5>Company Name</h5>,
    renderCell: (item) => item.entityLegalName,
  }),
  createTableColumn<ICompanyGroupCompany>({
    columnId: 'code',
    compare: (a, b) => a.companyCode.localeCompare(b.companyCode),
    renderHeaderCell: () => <h5>Company Code</h5>,
    renderCell: (item) => item.companyCode,
  }),
];

interface ICompanyGroupCompanyListProps {
  companies: ICompanyGroupCompany[];
}

const CompanyGroupCompanyList = ({ companies }: ICompanyGroupCompanyListProps): JSX.Element => {
  return (
    <FluentProvider theme={webLightTheme}>
      <DataGrid
        items={companies}
        columns={columns}
        sortable
        aria-label="Company List for Company Group"
        getRowId={(item) => item.companyCode}
      >
        <DataGridHeader>
          <DataGridRow>
            {({ renderHeaderCell }) => (
              <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
            )}
          </DataGridRow>
        </DataGridHeader>
        <DataGridBody<ICompanyGroupCompany>>
          {({ item, rowId }) => (
            <DataGridRow<ICompanyGroupCompany> key={rowId}>
              {({ renderCell }) => <DataGridCell>{renderCell(item)}</DataGridCell>}
            </DataGridRow>
          )}
        </DataGridBody>
      </DataGrid>
    </FluentProvider>
  );
};

export default CompanyGroupCompanyList;
